const e=r=>{try{return JSON.parse(r)}catch(t){return}};export{e as safeJsonParse};
//# sourceMappingURL=jsonUtils.js.map
